export const EDITORIAL_CONFIG = {
    ALLOWED_TAGS: [
        "p", "br", "a", "b", "strong", "i", "em", "u", "s",
        "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6",
        "blockquote", "pre", "code", "img", "span", "div",
        "table", "thead", "tbody", "tr", "th", "td",
    ],
    ALLOWED_ATTR: ["href", "title", "target", "rel", "src", "alt", "width", "height", "class", "id"],
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "onmouseover", "onmouseout", "onfocus", "onblur"],
    ALLOWED_URI_REGEXP: /^(https?:|mailto:|tel:|#|\/)/i,
};

export const EMBED_CONFIG = {
    ...EDITORIAL_CONFIG,
    ALLOWED_TAGS: [...EDITORIAL_CONFIG.ALLOWED_TAGS, "iframe"],
    ALLOWED_ATTR: [...EDITORIAL_CONFIG.ALLOWED_ATTR, "frameborder", "allowfullscreen", "allow"],
    ADD_URI_SAFE_ATTR: ["src"],
};
